const palette = {
  anakiwa: '#9BDFFF',
  anakiwa1: '#69CEFF',
  azure: '#366CB4',
  bigStone: '#1A2B42',
  blackRose: '#800632',
  blue: '#05AEFF',
  blue35: '#0098E0',
  blue40: '#75D3FF',
  blueRomance: '#DDFBE5',
  blueRomance1: '#BCF8CB',
  burgundy: '#B21E26',
  cello: '#244878',
  cello10: '#152337',
  cello30: '#274063',
  cello40: '#4571B0',
  cello60: '#4571B0',
  chelseaGem: '#986200',
  danube: '#6794D1',
  darkGrey: '#575B77',
  ebonyClay: '#2C2E3C',
  electricBlue: '#0016B2',
  ghost: '#B9BBCC',
  ghost1: '#BCBECA',
  grandis: '#FFD383',
  green: '#57ED7D',
  green40: '#54CA9F',
  green20: '#226D52',
  grey: '#BBBECB',
  gunPowder: '#414459',
  lavenderPink: '#FBA3C2',
  lightGrey: '#EAEBEE',
  lightGreen: '#136548',
  linkWater: '#E1EAF6',
  lochmara: '#0084C3',
  madang: '#9AF4B1',
  magenta40: '#EF3E7D',
  magenta20: '#920C3C',
  magenta60: '#F2A6C1',
  malachite: '#18DB49',
  malachite1: '#109231',
  mediumGrey: '#8F92A7',
  mint: '#57BFAB',
  mischka: '#DCDDE5',
  mischka1: '#E9E9ED',
  mischka2: '#D2D3DC',
  navy: '#345685',
  orange: '#FFB630',
  orange20: '#996300',
  orange40: '#FFB224',
  orient: '#005882',
  papayaWhip: '#FFF0D6',
  pattensBlue: '#CDEFFF',
  peach: '#FF9045',
  peach2: '#FFE2AC',
  periwinkleGray: '#D0DCED',
  pigPink: '#FDD1E1',
  pink: '#FF5E66',
  poloBlue: '#A2B9DA',
  poloBlue1: '#7397C8',
  purple: '#856BAA',
  razzmatazz: '#F41967',
  razzmatazz1: '#C1094B',
  sanJuan: '#274064',
  santasGray: '#9699B2',
  spindle: '#C2D4ED',
  spindle1: '#A4BFE3',
  stormGray: '#666A82',
  tickleMePink: '#F875A4',
  trout: '#444757',
  webOrange: '#E39300',
  white: '#FFFFFF'
};

export default palette;
